// Core
import { createApp, h } from 'vue'
import { createInertiaApp, Head, Link } from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia'
import { InertiaProgress } from '@inertiajs/progress'
import { createGtm } from '@gtm-support/vue-gtm';
import route from 'ziggy'
import VueCookies from 'vue3-cookies'

// Base setup
const el = document.getElementById('app');
InertiaProgress.init();

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({ el, app, props, plugin }) {

        const vueApp = createApp({ render: () => h(app, props) })

        const Ziggy = {
            ...props.initialPage.props.ziggy,
            location: window.location
        }

        vueApp
            .mixin({
                methods: {
                    $route: (name, params, absolute, config = Ziggy) => route(name, params, absolute, config),
                },
            })
            .mixin(require('../shared/translations'))
            .mixin(require('../shared/money'))
            .mixin(require('../shared/misc'))

        // 1: Relative path, 2: Recursive boolean, 3: Regex
        const requireLayout = require.context('./Layouts', false, /[A-Z]\w+\.(vue|js)$/);
        requireLayout.keys().forEach(fileName => {
            const layoutConfig = requireLayout(fileName);
            var fileName = fileName.split('/').pop().replace(/\.\w+$/, '') + 'Layout';
            vueApp.component(fileName, layoutConfig.default || layoutConfig);
        });

        const requireComponent = require.context('./Components', false, /[A-Z]\w+\.(vue|js)$/);
        requireComponent.keys().forEach(fileName => {
            const componentConfig = requireComponent(fileName);
            var fileName = fileName.split('/').pop().replace(/\.\w+$/, '');
            vueApp.component(fileName, componentConfig.default || componentConfig);
        });

        const gtmUrl = props.initialPage.props.__gtm_url || 'https://www.googletagmanager.com';
        const gtmId = props.initialPage.props.__gtm_id;

        vueApp
            .use(plugin)
            .use(createGtm({
                id: gtmId,
                source: gtmUrl + '/gtm.js',
                defer: true,
                compatibility: false,
                nonce: '2726c7f26c',
                enabled: !!gtmId,
                debug: false,
                loadScript: false,
                ignoredViews: [],
                trackOnNextTick: false,
            }))
            .use(VueCookies)
            .component('InertiaHead', Head)
            .component('InertiaLink', Link)
            .mount(el)
    },
});
